import React from 'react';
import { deliveryCards } from '../data/company';
import { renderRich } from '../utils/richText';
import { Card, CardFoot } from './Card';
import { RichList } from './RichList';
import { Section } from './Section';
export function DeliverySection() {
  return <Section id="entrega" number="05" title="Política de entrega y envíos" subtitle="Massive Faith LLC comercializa exclusivamente productos digitales. **No vendemos, fabricamos ni enviamos productos físicos**, así que no hay costos de envío, plazos de transporte, aduanas ni devoluciones de mercadería." data-id="element-31" data-mp="5lx1qg9d7hls">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-32" data-mp="of0zodtm8gm7">
        {deliveryCards.map(card => <Card key={card.title} data-id="element-33" data-mp="tc164pudnldu">
            <h3 className="mb-3 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-34" data-mp="tff8vz6ydwlt">{card.title}</h3>
            <RichList items={card.items} className="text-[14.5px]" data-id="element-35" data-mp="396jmqakkyup0" />
            {card.foot && <CardFoot data-id="element-36" data-mp="3e4uvsj31x166">{renderRich(card.foot)}</CardFoot>}
          </Card>)}
      </div>
    </Section>;
}